import React from "react"

import styles from './chip.module.css'

export function Chip({ children }) {
  return (
    <span role="presentation" className={styles.base}>
      {children}
    </span>
  )
}
